import React from 'react';

const StudyListExpandedRow = ({ children }) => {
  return (
    <div className="w-full bg-black py-4 pl-12 pr-2">
      <div className="block">{children}</div>
    </div>
  );
};


export default StudyListExpandedRow;
